
import React from 'react';
import Link from 'gatsby-link';
import './_feature-headline.scss';

const FeatureHeadline = ({children, title, subtitle, link, linktitle, devices, centered, contained, transparent, light}) => (
    <section className={'feature-headline' + (transparent?' transparent':'')}>
        <div className={'feature-headline--wrapper' + (centered?' centered':'') + (contained?' contained':'')}>
        {(devices?
            <small className={'feature-headline--subtitle' + (centered?' centered':'')}>Unsere Praxis ist an allen Arbeitsplätzen <Link to="/geraete" className="featured small">vollständig mit digitalen Geräten</Link> ausgestattet.</small>
            :subtitle?
                <small className={'feature-headline--subtitle' + (centered?' centered':'')}>{subtitle}</small>
                :''
        )}
        
        {(title?
            <h1 className={'feature-headline--title huge' + (centered?' centered':'') + (light?' light':' dark')}>
                {title}
            </h1>
            :''
        )}

        {(children?<p className={'feature-headline--content' + (centered?' centered':'')}>{children}</p>:'')}

        {(link&&linktitle?
            <a href={link} className="feature-headline--button button">
                {linktitle}
            </a>
            :''
        )}
        </div>
    </section>
)

export default FeatureHeadline



// WEBPACK FOOTER //
// ./src/components/headline/index.jsx